// src/docs/api/groups/suprimentosEndpoints.ts
import type { ApiEndpoint } from "../apiDocsSchema";

export const movimentationsEndpoints: ApiEndpoint[] = [
  {
    group: "Movimentações",
    name: "Movimentação de Serviço",
    method: "POST",
    path: "/movimentar-produtos-servico",
    usageDescription:
      "Essa API é utilizada em https://${seudominio}.com/estoque/estoque/realizar-movimentacao, sendo essencial para acesso ao sistema.",

    responseDetails:
      "Retorna no primeiro json dados referente ao usuário, em config (departamentos_ativos) é retornado quais departamentos o usuário atual pode acessar e/ou consultar, em theme é retornado configurações referente ao tema do sistema como cores principais normalmente semelhante ao padrão cromático da empresa contratante, em systemTitle é retornado o nome a ser utilizado no sistema.",
    description:
      "Retorna a lista de produtos visíveis para o departamento de suprimentos.",
    authRequired: true,
    developed: false,
    params: [
      {
        name: "page",
        in: "query",
        type: "number",
        required: false,
        description: "Página de resultados (default = 1).",
      },
    ],
    playgroundDefaults: {
      query: { page: "1" },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
  {
    group: "Movimentações",
    name: "Movimentação de Venda",
    method: "POST",
    path: "/movimentar-produtos-venda",
    usageDescription:
      "Essa API é utilizada em https://${seudominio}.com/estoque/estoque/realizar-movimentacao, sendo essencial para acesso ao sistema.",

    responseDetails:
      "Retorna no primeiro json dados referente ao usuário, em config (departamentos_ativos) é retornado quais departamentos o usuário atual pode acessar e/ou consultar, em theme é retornado configurações referente ao tema do sistema como cores principais normalmente semelhante ao padrão cromático da empresa contratante, em systemTitle é retornado o nome a ser utilizado no sistema.",
    description:
      "Retorna a lista de produtos visíveis para o departamento de suprimentos.",
    authRequired: true,
    developed: false,
    params: [
      {
        name: "page",
        in: "query",
        type: "number",
        required: false,
        description: "Página de resultados (default = 1).",
      },
    ],
    playgroundDefaults: {
      query: { page: "1" },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
  {
    group: "Movimentações",
    name: "Movimentação de Consumo",
    method: "POST",
    path: "/movimentar-produtos-consumo",
    usageDescription:
      "Essa API é utilizada em https://${seudominio}.com/estoque/estoque/realizar-movimentacao, sendo essencial para acesso ao sistema.",

    responseDetails:
      "Retorna no primeiro json dados referente ao usuário, em config (departamentos_ativos) é retornado quais departamentos o usuário atual pode acessar e/ou consultar, em theme é retornado configurações referente ao tema do sistema como cores principais normalmente semelhante ao padrão cromático da empresa contratante, em systemTitle é retornado o nome a ser utilizado no sistema.",
    description:
      "Retorna a lista de produtos visíveis para o departamento de suprimentos.",
    authRequired: true,
    developed: false,
    params: [
      {
        name: "page",
        in: "query",
        type: "number",
        required: false,
        description: "Página de resultados (default = 1).",
      },
    ],
    playgroundDefaults: {
      query: { page: "1" },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
  {
    group: "Movimentações",
    name: "Movimentação de Perda",
    method: "POST",
    path: "/movimentar-produtos-perda",
    usageDescription:
      "Essa API é utilizada em https://${seudominio}.com/estoque/estoque/realizar-movimentacao, sendo essencial para acesso ao sistema.",

    responseDetails:
      "Retorna no primeiro json dados referente ao usuário, em config (departamentos_ativos) é retornado quais departamentos o usuário atual pode acessar e/ou consultar, em theme é retornado configurações referente ao tema do sistema como cores principais normalmente semelhante ao padrão cromático da empresa contratante, em systemTitle é retornado o nome a ser utilizado no sistema.",
    description:
      "Retorna a lista de produtos visíveis para o departamento de suprimentos.",
    authRequired: true,
    developed: false,
    params: [
      {
        name: "page",
        in: "query",
        type: "number",
        required: false,
        description: "Página de resultados (default = 1).",
      },
    ],
    playgroundDefaults: {
      query: { page: "1" },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
];
